// icons.js
import ChatIcon from '@material-ui/icons/ChatOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';
import HelpIcon from '@material-ui/icons/Help';
import HomeIcon from '@material-ui/icons/HomeOutlined';
import FormatListBulletedIcon from '@material-ui/icons/ImportContacts';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ReportIcon from '@material-ui/icons/Report';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import LiveHelp from '@material-ui/icons/LiveHelp';
import StoreIcon from '@material-ui/icons/Store';
import PagesIcon from '@material-ui/icons/Pages';
import AssignmentIcon from '@material-ui/icons/Assignment';
import WorkOffIcon from '@material-ui/icons/WorkOff';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import AssignmentReturnOutlinedIcon from '@material-ui/icons/AssignmentReturnOutlined';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';
import WorkIcon from '@material-ui/icons/Work';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import RestorePageIcon from '@material-ui/icons/RestorePage';
import TodayIcon from '@material-ui/icons/Today';
import TouchAppIcon from '@material-ui/icons/TouchApp';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';

const icons = {
    ChatIcon,
    DashboardIcon,
    HelpIcon,
    HomeIcon,
    FormatListBulletedIcon,
    NotificationImportantIcon,
    PersonIcon,
    ReportIcon,
    ShoppingCartIcon,
    LiveHelp,
    StoreIcon,
    PagesIcon,
    AssignmentIcon,
    WorkOffIcon,
    AssessmentOutlinedIcon,
    AddBoxOutlinedIcon,
    StoreOutlinedIcon,
    AssignmentReturnOutlinedIcon,
    PersonOutlineOutlinedIcon,
    WorkIcon,
    HourglassFullIcon,
    LocalShippingIcon,
    RestorePageIcon,
    TodayIcon,
    TouchAppIcon,
    AssignmentIndIcon
};

export default icons;
